import { POSITION_MNG } from '@/api/apiModules'

export default {
  refreshInterval: false,
  viewType: 'table',
  module: POSITION_MNG,
  allowStatus: {},
  toolbar: {
    searchWidth: 320,
    searchPlaceholder: '请输入岗位名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['positionName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: '创建岗位',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'PositionCreate'
      }
    ]
  },
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '岗位名称',
          prop: 'positionName',
          width: 265,
          sortField: 'positionName'
        }
      },
      {
        props: {
          label: '岗位描述',
          prop: 'positionDesc'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          width: 160,
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160,
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'PositionEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'PositionDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.positionMng.deleteMsg'
        }
      }
    ]
  }
}
